import axios from 'axios';

// 地址档案列表查询
export const cityAddressQueryPage = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/cityAddressFileBO.ajax?cmd=queryPage',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 地址档案 - 新增/编辑保存
export const cityAddressSaveOrUpdate = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/cityAddressFileBO.ajax?cmd=saveOrUpdate',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 地址档案 - 模糊查询收货方
export const queryConsignee = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/cityAddressFileBO.ajax?cmd=queryConsignee',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 地址档案 - 查询档案信息
export const queryByAfId = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/cityAddressFileBO.ajax?cmd=queryByAfId',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 地址档案 - 删除档案信息
export const deleteByAfId = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/cityAddressFileBO.ajax?cmd=deleteByAfId',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 客户线路列表查询
export const cityCustomerLineQueryPage = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/cityCustomerLineBO.ajax?cmd=queryPage',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 客户线路 - 详情
export const cityCustomerLineQueryByLineId = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/cityCustomerLineBO.ajax?cmd=queryByLineId',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 客户线路 - 新增/编辑 保存线路信息
export const cityCustomerSaveOrUpdate = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/cityCustomerLineBO.ajax?cmd=saveOrUpdate',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});


// 客户订单 - 列表
export const cityCustomerOrderQueryPage = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/cityCustomerOrderBO.ajax?cmd=queryPage',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 客户订单 - 列表 - 取消订单
export const cityCustomerOrderDeleteByCcoId = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/cityCustomerOrderBO.ajax?cmd=deleteByCcoId',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 客户订单 - 查看详情
export const cityCustomerOrderQueryByCcoId = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/cityCustomerOrderBO.ajax?cmd=queryByCcoId',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 客户订单 - 保存
export const cityCustomerOrderSaveOrUpdate = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/cityCustomerOrderBO.ajax?cmd=saveOrUpdate',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 订单路径信息计算
export const cityCustomerOrderCompute = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/cityCustomerOrderBO.ajax?cmd=compute',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});
